import React from 'react';

interface Icon3DFullStackProps {
  size?: string;
}

const Icon3DFullStack: React.FC<Icon3DFullStackProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'stack-vertical 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(16, 185, 129, 0.3))' }}>
          <defs>
            <linearGradient id="fullstackGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#10b981" />
              <stop offset="50%" stopColor="#34d399" />
              <stop offset="100%" stopColor="#059669" />
            </linearGradient>
          </defs>
          <rect x="3" y="2" width="18" height="4" rx="0.5" fill="url(#fullstackGradient)" opacity="0.8" stroke="url(#fullstackGradient)" strokeWidth="0.5" />
          <rect x="3" y="8" width="18" height="4" rx="0.5" fill="url(#fullstackGradient)" opacity="0.5" stroke="url(#fullstackGradient)" strokeWidth="0.5" />
          <rect x="3" y="14" width="18" height="4" rx="0.5" fill="url(#fullstackGradient)" opacity="0.3" stroke="url(#fullstackGradient)" strokeWidth="0.5" />
          <circle cx="6" cy="4" r="0.7" fill="url(#fullstackGradient)" />
          <circle cx="6" cy="10" r="0.7" fill="url(#fullstackGradient)" opacity="0.7" />
        </svg>
        <style>{`
          @keyframes stack-vertical {
            0%, 100% { transform: rotateX(0deg) translateZ(0px); }
            50% { transform: rotateX(20deg) translateZ(4px); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DFullStack;
